import React, { useState, Fragment, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Authenticate } from "../../services/redux/AuthenticationReducer";
import { Link, useNavigate } from "react-router-dom";
import { LoginUser } from "../../services/redux/LoginReducer";
import { store } from "../../services/redux/store";
import { Dialog, Disclosure, Popover, Transition } from "@headlessui/react";
import {
  ArrowPathIcon,
  Bars3Icon,
  ChartPieIcon,
  CursorArrowRaysIcon,
  FingerPrintIcon,
  SquaresPlusIcon,
  XMarkIcon,
} from "@heroicons/react/24/outline";
import {
  ChevronDownIcon,
  PhoneIcon,
  PlayCircleIcon,
} from "@heroicons/react/20/solid";
import logo from "../../img/logo.png";
import showNotification from "../../services/redux/NotifcationService";
import { setKycRequestData } from "../../services/redux/KYCRequestReducer";
import { setV2PRMData } from "../../services/redux/V2PRMReducer";
import { setPendingData } from "../../services/redux/PendingReducer";
import { setMailSentData } from "../../services/redux/MailSentReducer";
import { setAcceptedData } from "../../services/redux/AcceptedReducer";
import { setDetailsData } from "../../services/redux/DetailsReducer";
import { setFiltersData } from "../../services/redux/FilterReducer";
import { setCustomerData } from "../../services/redux/CustomerDataReducer";

const DashboardHeader = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loginData = useSelector((state) => state.login.loginData);
  const [isSmallScreen, setIsSmallScreen] = React.useState(false);

  function logout() {
    localStorage.clear();
    dispatch(Authenticate(false));
    dispatch(LoginUser(""));
    dispatch(setV2PRMData(""));
    dispatch(setPendingData(""));
    dispatch(setMailSentData(""));
    dispatch(setAcceptedData(""));
    dispatch(setDetailsData(""));
    dispatch(setFiltersData(""));
    dispatch(setCustomerData(""));
    dispatch(setKycRequestData(""));
    navigate("/");
  }

  // Function to check screen size
  const checkScreenSize = () => {
    setIsSmallScreen(window.innerWidth > 1445); // Adjust the breakpoint as needed
  };

  // Add event listener for resizing
  useEffect(() => {
    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);
    return () => {
      window.removeEventListener("resize", checkScreenSize);
    };
  }, [isSmallScreen]);

  return (
    <header
      style={{ backgroundColor: "rgba(255, 255, 255,1)" }}
      className="shadow-sm"
    >
      <nav
        className="mx-auto flex max-w-7xl items-center justify-between p-3 lg:px-8"
        aria-label="Global"
      >
        <div className="flex lg:flex-1">
          <div className="-m-1.5 p-1.5">
            <span className="sr-only">Your Company</span>
            {isSmallScreen ? null : (
              <>
                <img className="h-8 w-auto" src={logo} alt="" />
              </>
            )}
          </div>
        </div>
        <div className="flex md:hidden">
          <button
            type="button"
            className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-700"
            onClick={() => setMobileMenuOpen(true)}
          >
            <span className="sr-only">Open main menu</span>
            <Bars3Icon className="h-6 w-6" aria-hidden="true" />
          </button>
        </div>
        <div className="hidden md:flex lg:flex lg:justify-end">
          <div className="mx-3 items-center">
            <Link to="/mailSent">Onboarding</Link>
          </div>
          <div className="mx-3 items-center">
            <Link to="/V2PRM">V2PRM</Link>
          </div>
          {/* <div className="mx-3 text-sm font-semibold leading-6 text-gray-900">
            <Popover className="relative">
              <Popover.Button className="flex border-none outline-none items-center gap-x-1 text-sm font-semibold leading-6 text-gray-900">
                KYC
                <ChevronDownIcon className="h-5 w-5 flex-none text-gray-400" aria-hidden="true" />
              </Popover.Button>

              <Transition
                as={Fragment}
                enter="transition ease-out duration-200"
                enterFrom="opacity-0 translate-y-1"
                enterTo="opacity-100 translate-y-0"
                leave="transition ease-in duration-150"
                leaveFrom="opacity-100 translate-y-0"
                leaveTo="opacity-0 translate-y-1"
              >
                <Popover.Panel className="absolute -right-5 top-full z-10 mt-3 w-max max-w-md overflow-hidden rounded-2xl bg-white shadow-lg ring-1 ring-gray-900/5">
                  <div className="p-4 flex items-center space-x-2 hover:cursor-pointer" onClick={() => navigate('/KYC')}>
                    <span>Generate Request</span>
                  </div>
                  <div className="p-4 flex items-center space-x-2 hover:cursor-pointer" onClick={() => navigate('/ListRequests')}>
                    <span>List Requests</span>
                  </div>
                  <div className="p-4 flex items-center space-x-2 hover:cursor-pointer" onClick={() => navigate('/KYCComparison')}>
                    <span>Compare KYC</span>
                  </div>
                  <div className="p-4 flex items-center space-x-2 hover:cursor-pointer" onClick={() => navigate('/UploadFile')}>
                    <span>Upload file for comparison</span>
                  </div>
                </Popover.Panel>
              </Transition>
            </Popover>
          </div> */}
          <a
            href="#"
            className="mx-3 text-sm font-semibold leading-6 text-gray-900"
          >
            <Popover className="relative">
              <Popover.Button className="flex border-none outline-none items-center gap-x-1 text-base font-semibold leading-6 text-gray-900">
                Welcome! {loginData?.firstName || ""}{" "}
                {loginData?.lastName || ""}
                <ChevronDownIcon
                  className="h-5 w-5 flex-none text-gray-400"
                  aria-hidden="true"
                />
              </Popover.Button>

              <Transition
                as={Fragment}
                enter="transition ease-out duration-200"
                enterFrom="opacity-0 translate-y-1"
                enterTo="opacity-100 translate-y-0"
                leave="transition ease-in duration-150"
                leaveFrom="opacity-100 translate-y-0"
                leaveTo="opacity-0 translate-y-1"
              >
                <Popover.Panel className="absolute -right-5 top-full z-10 mt-3 w-max max-w-md overflow-hidden rounded-3xl bg-white shadow-lg ring-1 ring-gray-900/5">
                  <div
                    className="p-4 flex items-center space-x-2"
                    onClick={logout}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                      className="w-6 h-6"
                    >
                      <path
                        fillRule="evenodd"
                        d="M7.5 3.75A1.5 1.5 0 0 0 6 5.25v13.5a1.5 1.5 0 0 0 1.5 1.5h6a1.5 1.5 0 0 0 1.5-1.5V15a.75.75 0 0 1 1.5 0v3.75a3 3 0 0 1-3 3h-6a3 3 0 0 1-3-3V5.25a3 3 0 0 1 3-3h6a3 3 0 0 1 3 3V9A.75.75 0 0 1 15 9V5.25a1.5 1.5 0 0 0-1.5-1.5h-6Zm5.03 4.72a.75.75 0 0 1 0 1.06l-1.72 1.72h10.94a.75.75 0 0 1 0 1.5H10.81l1.72 1.72a.75.75 0 1 1-1.06 1.06l-3-3a.75.75 0 0 1 0-1.06l3-3a.75.75 0 0 1 1.06 0Z"
                        clipRule="evenodd"
                      />
                    </svg>
                    <span>Log Out</span>
                  </div>
                </Popover.Panel>
              </Transition>
            </Popover>
          </a>
        </div>
      </nav>
      <Dialog
        as="div"
        className="lg:hidden"
        open={mobileMenuOpen}
        onClose={setMobileMenuOpen}
      >
        <div className="fixed inset-0 z-10" />
        <Dialog.Panel className="fixed inset-y-0 right-0 z-10 w-full overflow-y-auto bg-white px-6 py-6 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10">
          <div className="flex items-center justify-between">
            <a href="#" className="-m-1.5 p-1.5">
              <span className="sr-only">Your Company</span>
              {/* <img
                className="h-8 w-auto"
                src="https://tailwindui.com/img/logos/mark.svg?color=indigo&shade=600"
                alt=""
              /> */}
            </a>
            <button
              type="button"
              className="-m-2.5 rounded-md p-2.5 text-gray-700"
              onClick={() => setMobileMenuOpen(false)}
            >
              <span className="sr-only">Close menu</span>
              <XMarkIcon className="h-6 w-6" aria-hidden="true" />
            </button>
          </div>
          <div className="mt-6 flow-root">
            <div className="-my-6 divide-y divide-gray-400">
              <div className="p-4 flex items-center space-x-2 hover:cursor-pointer">
                Onboarding List
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="w-6 h-6"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M18 7.5v3m0 0v3m0-3h3m-3 0h-3m-2.25-4.125a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0ZM3 19.235v-.11a6.375 6.375 0 0 1 12.75 0v.109A12.318 12.318 0 0 1 9.374 21c-2.331 0-4.512-.645-6.374-1.766Z"
                  />
                </svg>
                <Link to="/mailSent">Onboarding</Link>
              </div>
              <div className="p-4 flex items-center space-x-2 hover:cursor-pointer">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="w-6 h-6"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M12 9v6m3-3H9m12 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                  />
                </svg>
                <Link to="/V2PRM">V2PRM</Link>
              </div>
              {/* <div className="p-4 flex items-center space-x-2 hover:cursor-pointer" onClick={() => navigate('/KYC')}>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M15 9h3.75M15 12h3.75M15 15h3.75M4.5 19.5h15a2.25 2.25 0 0 0 2.25-2.25V6.75A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25v10.5A2.25 2.25 0 0 0 4.5 19.5Zm6-10.125a1.875 1.875 0 1 1-3.75 0 1.875 1.875 0 0 1 3.75 0Zm1.294 6.336a6.721 6.721 0 0 1-3.17.789 6.721 6.721 0 0 1-3.168-.789 3.376 3.376 0 0 1 6.338 0Z" />
                </svg>
                <span>Generate KYC Request</span>
              </div>
              <div className="p-4 flex items-center space-x-2 hover:cursor-pointer" onClick={() => navigate('/ListRequests')}>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 6.75h12M8.25 12h12m-12 5.25h12M3.75 6.75h.007v.008H3.75V6.75Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0ZM3.75 12h.007v.008H3.75V12Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm-.375 5.25h.007v.008H3.75v-.008Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z" />
                </svg>
                <span>List Requests</span>
              </div>
              <div className="p-4 flex items-center space-x-2 hover:cursor-pointer" onClick={() => navigate('/KYCComparison')}>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M7.5 21 3 16.5m0 0L7.5 12M3 16.5h13.5m0-13.5L21 7.5m0 0L16.5 12M21 7.5H7.5" />
                </svg>
                <span>Compare KYC</span>
              </div>
              <div className="p-4 flex items-center space-x-2 hover:cursor-pointer" onClick={() => navigate('/UploadFile')}>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5m-13.5-9L12 3m0 0 4.5 4.5M12 3v13.5" />
                </svg>
                <span>Upload file for comparison</span>
              </div> */}
              <div
                className="p-4 flex items-center space-x-2 hover:cursor-pointer"
                onClick={logout}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="w-6 h-6"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M5.636 5.636a9 9 0 1 0 12.728 0M12 3v9"
                  />
                </svg>
                <span>Log Out</span>
              </div>
              <div className="p-4 flex items-center space-x-2 hover:cursor-pointer"></div>
            </div>
          </div>
        </Dialog.Panel>
      </Dialog>
    </header>
  );
};

export default DashboardHeader;
